import { WindProductionUnit } from "./WindProductionUnit";
export default WindProductionUnit;
